import styled from 'styled-components'
import GENERAL_STYLE from '../../../generalStyle'
import { COLORS } from '../../../Utils/colors'
// const COLORS = {
//   deepBlue: '#3899ec',
//   lightBlue: '#f6fbff',
//   mediumBlue: '#eaf7ff',
//   wixGrey: '#d9e1e8',
//   darkText: '#2B5672',
//   hoverBlue: '#cfeeff',
//   hoverBlueDark: '#4eb7f5',
//   darkBlue: '#2b81cb',
//   red: '#f5425d',
//   darkLightBlue: '#9CBFF3',
//   superDarkBlue: '#0d487f'
// }

export const Panel = styled.div`
    height: 100vh;
    width: ${GENERAL_STYLE.EDIT_SLIDE_WIDTH_RIGHT_PANEL};
    border: 1px solid #D6E1E8;
    border-top: none;
    border-right: 0px;
    display: flex;
    flex-direction: column;
    /* overflow: hidden; */
    display: flex;
    flex-shrink: 0;
    /* добавляю 1px чтобы не было горизонтальной прокрутки */
    flex: 0 0 calc(${GENERAL_STYLE.EDIT_SLIDE_WIDTH_RIGHT_PANEL} + 1px);
    transition: .2s;
    transform-origin: right;
    color: ${GENERAL_STYLE.MAIN_TEXT_COLOR};
    position: relative;
    background-color: #fff;

    .input-stepper>input::selection{
      background-color: rgba(48, 232, 241, 0.3) !important;
    }

    /* у виксовских колор-слайдеров в квадратных элементах с цветом по краям могут быть видны отступы */
    .color-picker-input>.color-picker-wrapper>.color-picker-color {
      top: -5px;
      bottom: -5px;
      left: -5px;
      right: -5px;
    }
`
export const SettingsContainer = styled.div`
    position: absolute;
    width: ${GENERAL_STYLE.EDIT_SLIDE_WIDTH_RIGHT_PANEL};
    display:  none;
    /* transition: .5s;
    transform-origin: right; */
`

export const DrillDownContainer = styled.div`
    /* transition: .25s;
    transform-origin: right; */
`

export const GetNav = (props) => {

    if (props.back) {
        const NavStyle = styled.div`
        width:100%;
        height: 43px;
        background-color: #FFFFFF;
        text-align: left;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0 25px;
        font-size: 16px;
        &:hover {
            color: #3899EC;
        }
        
    `
        return (
            <NavStyle onClick={e=>{props.onClick()}}>
                <Icon type='hover' name='arrow-left' size={'18px'}/>
            </NavStyle>
        )
    } else {
        const NavStyle = styled.div`
        height: 43px;
        width:100%;
        background-color: #F9F9F9;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-size: 16px;
        border-bottom: 1px solid #D6E1E8;

    `
        return (
            <NavStyle>
                {props.children}
            </NavStyle>
        )
    }
}

export const DrilldownElement = styled.div`
  
    position: relative;
    padding: 18px 18px;
    border-bottom: 1px solid #d9e1e8;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    span{
        font-size: 14px;
        color: #162d3d;
        line-height: 19.2px;
    }

    &:hover{
        div:not(.fade){
            background-color: #d3edff;

        }
    }
` 

export const NavigationArrowContainer = styled.div`
    border-radius: 50%;
    background-position: center;
    background-repeat: no-repeat;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      display: block;
    }

` 
export const CollapseWrapper = styled.div`
  position: relative;
  overflow: hidden;
  transition: all 1s ease-in-out;
  /* margin-bottom: 3px; */
  max-height: ${props => props.wrapperHeight ? props.wrapperHeight + 'px' : 'none'};
  ${ props => props.collapse ? 'max-height: 0;' : ''}
`
export const CollapseHeader = styled.div`
    position: relative;
    /* .control-section-divider.labeled {
    } */
    &:after{
        display: block;
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        cursor: pointer;
        transition: all .4s ease;
    }
    &:before {
      display: block;
      content: '';
      position: absolute;
      top: 50%;
      left: 20px;
      width: 0;
      height: 0;
      border: 5px solid transparent;
      border-left: 5px solid rgba(43,86,114,0.5);
      transform: translateY(-5px) rotate(${ props => props.collapse ? '0deg' : '90deg'});
      transform-origin: 1px center;
      transition: transform .4s ease;
      z-index: 1;
    }
    &:hover {
        &:after {
            background-color: rgba(0,0,0,0.05);
        }
        &:before {
            border-left: 5px solid rgba(56,153,236,1);
        }
    }
`

    // color: ${props => props.isActive ? 'rgba(43,86,114,0.5)' : 'rgba(43,86,114,0.5)'};
export const ArrowIcon = styled.div`
    position: absolute;
    top: 0;
    left: 14px;
    bottom: 0;
    /* width: 42px; */
    /* height: 42px; */
    /* transform: translate(14px, -42px); */
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 20px;
    /* transi */
    color: rgba(43,86,114,0.5);
    transition: all .4s ease;
    &>div{
      /* transition-duration: 0.5s, 0.5s;
      transition-timing-function: ease-out, ease;
      transition-property: transform, color; */
      transition: all .4s ease;
      transform-origin: left center;
      transform: rotate(0deg);
    }
`
      // /* transform: ${props => props.isActive ? `rotate(90deg)` : `rotate(0deg)`}; */

export const BackButtonContainer = styled.div`
    width: 100%;
    background-color: #fff;
    /* тут нужен нижний бордер чтобы видно было границу во время прокрутки */
    border-bottom: 1px solid #d9e1e8;
`
export const TabHeader = styled.div`
    display: flex;
    /* border-top: 1px solid #d9e1e8; */
    border-bottom: 1px solid #d9e1e8;
`
export const TabTitle = styled.div`
    flex: 1;
    padding: 22px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    color: ${props => props.isActive ? COLORS.deepBlue : props.blocked ? '#D6E1E8' : 'inherit' };
    font-size: 16px;
    line-height: 16px;
    text-align: center;
    cursor: ${props => props.blocked ? 'auto' : 'pointer'};

    &:before {
        display: ${props => props.isActive ? 'block' : 'none' };
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 3px;
        background-color: ${COLORS.deepBlue};
    }
    &:after {
        display: ${props => props.isActive ? 'block' : 'none' };
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0 6px 7px 6px;
        border-color: transparent transparent ${COLORS.deepBlue} transparent;
        bottom: 1px;
        left: 50%;
        transform: translateX(-50%);
    }
`

export const AngleIcon = styled.div`
    width: 11px;
    height: 16px;
    position: relative;
    overflow: hidden;
    &:before, &:after {
        display: block;
        content: '';
        position: absolute;
        width: 9px;
        height: 9px;
        ${props => props.direction === 'right' ? 'right: 0;' : 'left: 0;'}
        bottom: 50%;
        transform-origin: ${props => props.direction === 'right' ? 'right bottom' : 'left bottom'};
        
    }
    &:before {
        background-color: ${COLORS.deepBlue};
        transform: ${props => props.direction === 'right' ? 'rotate(-45deg)' : 'rotate(45deg)'};
    }
    &:after {
      background-color: #fff;
      transform: ${props => props.direction === 'right' ? 'translate(-4px, 0) rotate(-45deg)' : 'translate(4px, 0) rotate(45deg)'};
    }
`

// export const SettingsContainer = styled.div`
//     position: absolute;
//     width: ${GENERAL_STYLE.EDIT_SLIDE_WIDTH_RIGHT_PANEL};
//     display: none;
//     transition: .5s;
//     transform-origin: right;
// `

export const Scrollbar = styled.div`
/*
 * Container style
 */
.ps {
  overflow: hidden !important;
  overflow-anchor: none;
  -ms-overflow-style: none;
  touch-action: auto;
  -ms-touch-action: auto;
}

/*
 * Scrollbar rail styles
 */
.ps__rail-x {
  display: none;
  opacity: 0;
  transition: background-color .2s linear, opacity .2s linear;
  -webkit-transition: background-color .2s linear, opacity .2s linear;
  height: 15px;
  /* there must be 'bottom' or 'top' for ps__rail-x */
  bottom: 0px;
  /* please don't change 'position' */
  position: absolute;
}

.ps__rail-y {
  display: none;
  opacity: 0;
  transition: background-color .2s linear, opacity .2s linear;
  -webkit-transition: background-color .2s linear, opacity .2s linear;
  width: 15px;
  /* there must be 'right' or 'left' for ps__rail-y */
  right: 0;
  /* please don't change 'position' */
  position: absolute;
  z-index: 999999;
}

.ps--active-x > .ps__rail-x,
.ps--active-y > .ps__rail-y {
  display: block;
  background-color: transparent;
}

.ps:hover > .ps__rail-x,
.ps:hover > .ps__rail-y,
.ps--focus > .ps__rail-x,
.ps--focus > .ps__rail-y,
.ps--scrolling-x > .ps__rail-x,
.ps--scrolling-y > .ps__rail-y {
  opacity: 0.6;
}

.ps .ps__rail-x:hover,
.ps .ps__rail-y:hover,
.ps .ps__rail-x:focus,
.ps .ps__rail-y:focus,
.ps .ps__rail-x.ps--clicking,
.ps .ps__rail-y.ps--clicking {
  background-color: rgba(78,183,245,.2);
  opacity: 0.9;
}

/*
 * Scrollbar thumb styles
 */
.ps__thumb-x {
  background-color: rgba(78,183,245,.7);
  border-radius: 6px;
  transition: background-color .2s linear, height .2s ease-in-out;
  -webkit-transition: background-color .2s linear, height .2s ease-in-out;
  height: 6px;
  /* there must be 'bottom' for ps__thumb-x */
  bottom: 2px;
  /* please don't change 'position' */
  position: absolute;
}

.ps__thumb-y {
  background-color: rgba(78,183,245,.7);
  border-radius: 6px;
  transition: background-color .2s linear, width .2s ease-in-out;
  -webkit-transition: background-color .2s linear, width .2s ease-in-out;
  width: 6px;
  /* there must be 'right' for ps__thumb-y */
  right: 2px;
  /* please don't change 'position' */
  position: absolute;
}

.ps__rail-x:hover > .ps__thumb-x,
.ps__rail-x:focus > .ps__thumb-x,
.ps__rail-x.ps--clicking .ps__thumb-x {
  background-color: rgba(78,183,245,1);
  height: 11px;
}

.ps__rail-y:hover > .ps__thumb-y,
.ps__rail-y:focus > .ps__thumb-y,
.ps__rail-y.ps--clicking .ps__thumb-y {
  background-color: rgba(78,183,245,1);
  width: 11px;
}

/* MS supports */
@supports (-ms-overflow-style: none) {
  .ps {
    overflow: auto !important;
  }
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .ps {
    overflow: auto !important;
  }
}
`